import React from 'react';

const MARKET_PROFILES = [
  { id: 'US', label: 'US', caption: 'NASDAQ + NYSE' },
  { id: 'CA', label: 'CA', caption: 'TSX Momentum' },
  { id: 'VN', label: 'VN', caption: 'HoSE Growth' }
];

export default function MarketSelector({ market, onMarketChange, compact = false }) {
  return (
    <div className={`market-selector ${compact ? 'compact' : ''}`}>
      {MARKET_PROFILES.map((profile) => (
        <button
          key={profile.id}
          className={market === profile.id ? 'market-pill active' : 'market-pill'}
          onClick={() => onMarketChange(profile.id)}
          title={profile.caption}
        >
          {profile.label}
        </button>
      ))}
    </div>
  );
}
